import React from "react";

export default function ProductBottomFooter() {
  return (
    <>
      <div className="pbf-wrap">
        <div className="pbf-top-line" />

        <div className="pbf-row">
          <button className="pbf-left-btn">
            <span className="pbf-left-icon">▣</span>
            <span>Domo de facets</span>
            <span className="pbf-caret">▾</span>
          </button>

          <div className="pbf-center-text">
           
          </div>

          <button className="pbf-right-btn">
            <span className="pbf-right-icon">⊘</span>
            <span>Retirer dossier</span>
          </button>
        </div>

        <div className="pbf-bottom-meta">
          <span></span>
          <span></span>
        </div>
      </div>

      <style>{`
        .pbf-wrap {
          margin-top: 18px;
          padding-bottom: 8px;
        }

        .pbf-top-line {
          height: 1px;
          background: rgba(120,138,196,0.18);
          margin-bottom: 10px;
        }

        .pbf-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 14px;
          min-height: 48px;
        }

        .pbf-left-btn,
        .pbf-right-btn {
          height: 38px;
          border-radius: 8px;
          border: 1px solid rgba(255,255,255,0.08);
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          font-size: 13px;
          white-space: nowrap;
        }

        .pbf-left-btn {
          min-width: 136px;
          padding: 0 12px;
          background: rgba(255,255,255,0.04);
          color: #e5ecff;
          flex-shrink: 0;
        }

        .pbf-left-icon {
          font-size: 12px;
          opacity: 0.9;
        }

        .pbf-caret {
          font-size: 12px;
          opacity: 0.9;
        }

        .pbf-center-text {
          flex: 1;
          min-width: 180px;
          color: #aeb9dc;
          font-size: 11px;
          line-height: 1.45;
          text-align: left;
        }

        .pbf-right-btn {
          min-width: 118px;
          padding: 0 16px;
          background: linear-gradient(180deg, #b74c43, #9e3e37);
          color: #fff4f2;
          flex-shrink: 0;
        }

        .pbf-right-icon {
          font-size: 12px;
          opacity: 0.95;
        }

        .pbf-bottom-meta {
          margin-top: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          color: #7280ab;
          font-size: 9px;
          line-height: 1.3;
        }

        @media (max-width: 900px) {
          .pbf-row {
            flex-direction: column;
            align-items: stretch;
          }

          .pbf-left-btn,
          .pbf-right-btn {
            width: 100%;
          }

          .pbf-center-text {
            min-width: 0;
          }

          .pbf-bottom-meta {
            flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>
    </>
  );
}